import { format } from "date-fns";

export default (year: string) => {
  const chosenYear = Number(year);
  const start = new Date(chosenYear, 0, 1);
  const end = new Date(chosenYear, 11, 31);

  return {
    from: format(start, "yyyy-MM-dd"),
    to: format(end, "yyyy-MM-dd"),
  };
};
